import pluralize from 'pluralize';

import { Heading16 } from 'approot/shared/styles/typography.style';
import Text from 'approot/shared/styles/typography/text';
import { ContentPointBody } from './content-point-body';
import { ContentPoint } from './content-points.constants';

type Props = {
  contentPoints: ContentPoint[];
};

const ContentPointsView = ({ contentPoints }: Props) => {
  return (
    <>
      <Heading16 as="h4" marginBottom={0} marginTop={12}>
        {pluralize('Content Point', contentPoints.length)}
      </Heading16>
      {contentPoints.map((contentPoint, index) => (
        <Text key={contentPoint.id} $marginTop={index === 0 ? 0 : 12}>
          <ContentPointBody content={contentPoint.content} />
        </Text>
      ))}
    </>
  );
};

export default ContentPointsView;
